// Dollar Prices State

export default {
  dollarPricesList: [],
  lastDollarPrice: '',
  dollarPriceInfo: {}
}
